export default __webpack_public_path__ + "static/media/about2.6a7a5453.jpg";